export function getPetEvent(kind) {
	return {
		importantDate: {
			title: 'Важная дата',
			emoji: '⏰',
		},
		document: {
			title: 'Документ',
			emoji: '📦',
		},
		'vaccination:rabies': {
			title: 'Вакцинация от бешенства',
			emoji: '💉',
		},
		'vaccination:complex': {
			title: 'Комплексная вакцинация',
			emoji: '💉',
		},
		'medicine:injection': {
			title: 'Укол',
			emoji: '💉',
		},
		'medicine:pills': {
			title: 'Таблетки',
			emoji: '💊',
		},
		'medicine:drops': {
			title: 'Капли',
			emoji: '💧',
		},
		'appointment:veterinary': {
			title: 'Ветеринар',
			emoji: '👩‍⚕️',
		},
		'appointment:groomer': {
			title: 'Грумер',
			emoji: '💅',
		},
		'appointment:cynology': {
			title: 'Кинолог',
			emoji: '🎾',
		},
		'appointment:psychologist': {
			title: 'Зоопсихолог',
			emoji: '🧐',
		},
		'appointment:dogsitter': {
			title: 'Ситтер',
			emoji: '🐶',
		},
		'appointment:dogwalker': {
			title: 'Выгульщик',
			emoji: '🦮',
		},
		'appointment:hotel': {
			title: 'Передержка',
			emoji: '🏠',
		},
		'appointment:playdate': {
			title: 'Встреча',
			emoji: '❤️',
		},
		'health:foodchange': {
			title: 'Изменение еды',
			emoji: '🍖',
		},
		'health:allergy': {
			title: 'Аллергия',
			emoji: '🤢',
		},
		'health:surgery': {
			title: 'Операция',
			emoji: '🏥',
		},
		'health:cyclestart': {
			title: 'Старт цикла',
			emoji: '🌸',
		},
		'health:cycleend': {
			title: 'Конец цикла',
			emoji: '🌸',
		},
		chatConsultation: {
			title: 'Консультация',
			emoji: '👩‍💻',
		},
		vaccine: {
			title: 'Вакцина',
			emoji: '💉',
		},
		'vaccine:other': {
			title: 'Вакцина',
			emoji: '💉',
		},
		'vaccine:rabies': {
			title: 'Вакцина от бешенства',
			emoji: '💉',
		},
		'vaccine:complex': {
			title: 'Комплексная вакцинация',
			emoji: '💉',
		},
		'vaccine:revaccination': {
			title: 'Ревакцинация',
			emoji: '💉',
		},
		drug: {
			title: 'Лекарство',
			emoji: '💊',
		},
		'drug:ticks': {
			title: 'Обработка от клещей',
			emoji: '🦋',
		},
		'drug:parasites': {
			title: 'Обработка от паразитов',
			emoji: '🐛',
		},
		veterinary: {
			title: 'Ветеринар',
			emoji: '👩‍⚕️',
		},
		allergy: {
			title: 'Аллергия',
			emoji: '🤢',
		},
		checkup: {
			title: 'Чекап',
			emoji: '🏥',
		},
		test: {
			title: 'Анализы',
			emoji: '🧪',
		},
		surgery: {
			title: 'Операция',
			emoji: '🏥',
		},
		periodstart: {
			title: 'Старт цикла',
			emoji: '🌸',
		},
		periodend: {
			title: 'Конец цикла',
			emoji: '🌸',
		},
		custom: {
			title: 'Другое',
			emoji: '🤷‍♂️',
		},
		grooming: {
			title: 'Груминг',
			emoji: '💅',
		},
		cynology: {
			title: 'Кинолог',
			emoji: '🎾',
		},
		psychologist: {
			title: 'Зоопсихолог',
			emoji: '🧐',
		},
		dogsitter: {
			title: 'Ситтер',
			emoji: '🐶',
		},
		dogwalker: {
			title: 'Выгульщик',
			emoji: '🦮',
		},
		hotel: {
			title: 'Передержка',
			emoji: '🏠',
		},
		walk: {
			title: 'Прогулка',
			emoji: '🦮',
		},
		teeth: {
			title: 'Уход за зубами',
			emoji: '🦷',
		},
		nails: {
			title: 'Когтитюр',
			emoji: '💅',
		},
		training: {
			title: 'Тренировка',
			emoji: '🏋️',
		},
		party: {
			title: 'Праздник',
			emoji: '🎉',
		},
		contest: {
			title: 'Конкурс',
			emoji: '🏆',
		},
		document: {
			title: 'Документ',
			emoji: '📦',
		},
		importantDate: {
			title: 'Важная дата',
			emoji: '⏰',
		},
		rabiesVaccination: {
			title: 'Вакцинация от бешенства',
			emoji: '💉',
		},
		complexVaccination: {
			title: 'Комплексная вакцинация',
			emoji: '💉',
		},
		acariTreatment: {
			title: 'Обработка от клещей',
			emoji: '🦋',
		},
		parasiteTreatment: {
			title: 'Обработка от паразитов',
			emoji: '🐛',
		},
	}[kind]
}

export function getPetDocument(kind) {
	return {
		prescription: 'Выписка',
		vetBill: 'Чек',
		labTest: 'Анализы',
		passport: 'Ветпаспорт',
		treatmentPlan: 'План лечения',
		ultrasound: 'УЗИ',
		ctScan: 'КТ',
		mri: 'МРТ',
		xray: 'Рентген',
		other: 'Другое',
	}[kind]
}
